import React, {useState, useEffect} from "react";
import Table from "../../../../../app/components/Table"
import Pagination from "../../../../../app/components/Pagination";

const Errors = ({setCount}) => {
    const columns = [
    { campo: 'remetente', titulo: 'Remetente' },
    { campo: 'assunto', titulo: 'Assunto' },
    { campo: 'destinatario', titulo: 'Destinatários' },
    { campo: 'templates', titulo: 'Templates' },
    { campo: 'status', titulo: 'Status' },
    { campo: 'enviado_em', titulo: 'Enviado em' },
  ];

  const [dataErrors, setDataErrors] = useState([
     ]);
  useEffect(() => {
    setCount(dataErrors.length);
  }, [dataErrors, setCount]);

    const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(dataErrors.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const indexStart = (currentPage - 1) * itemsPerPage;
  const indexEnd = indexStart + itemsPerPage;
  const paginatedData = dataErrors.slice(indexStart, indexEnd);

  return (
    <div>
      {paginatedData.length > 0 ? (
      <>
        <Table colunas={columns} dados={paginatedData} />

        {dataErrors.length > itemsPerPage && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            showPageNumbers={true}
            maxPageNumbers={8}
          />
        )}
      </>
    ) : (
      <div className="text-center text-gray-500 py-8">
        Nenhum e-mail com erro.
      </div>
    )}
    </div>
  );
};

export default Errors